export enum NetWorthRoutePathsEnum {
  NET_WORTH = '/net-worth',
}
